export default "__VITE_ASSET__Cq68cxBA__"